// NOTE: this component is not currently used anywhere
import React, { useEffect } from 'react';

import cn from 'classnames';
import { useControls } from 'react-zoom-pan-pinch';

import zoomInIcon from 'assets/images/inspection/zoom-in.svg';
import zoomOutIcon from 'assets/images/inspection/zoom-out.svg';

import './ZoomControl.scss';

type ControlsType = {
  imagePosition: { x: number; y: number; scale: number };
  className?: string;
};
export const ZoomControl = ({
  imagePosition: { x, y, scale },
  className,
}: ControlsType) => {
  const { setTransform, zoomIn, zoomOut } = useControls();

  useEffect(() => {
    setTransform(x, y, scale);
  }, [scale, x, y]);

  return (
    <div className={cn('ZoomControl', className)}>
      <img src={zoomInIcon} onClick={() => zoomIn()} alt="zoom-in" />

      <img src={zoomOutIcon} onClick={() => zoomOut()} alt="zoom-out" />

      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={() => setTransform(x, y, scale)} className="ZoomControl_Close">
        &#10006;
      </div>
    </div>
  );
};
